import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { XOctagon, Ban } from "lucide-react";

// Non-celebratory terminal treatment for failed / cancelled Runs. The graph
// behind it is desaturated (Canvas `dimmed`) — this is the record, not an outcome reveal.
export default function TerminalOverlay({ kind, reason, reducedMotion }) {
  const { t } = useTranslation();
  const failed = kind === "failed";
  const Icon = failed ? XOctagon : Ban;
  const anim = reducedMotion ? {} : { initial: { opacity: 0, scale: 0.96 }, animate: { opacity: 1, scale: 1 }, transition: { duration: 0.5 } };
  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-testid="dg-terminal-overlay" data-kind={kind}>
      <motion.div {...anim}
        className="pointer-events-auto max-w-md rounded-2xl border border-[var(--qn-border-hover)] bg-[var(--qn-glass)] backdrop-blur-md px-7 py-6 text-left shadow-2xl">
        <div className="flex items-center gap-3">
          <Icon className={`w-6 h-6 ${failed ? "text-[var(--qn-error)]" : "text-[var(--qn-foreground-muted)]"}`} />
          <div className="text-base font-semibold text-[var(--qn-foreground)]" data-testid="dg-terminal-title">
            {t(failed ? "decisionGraph.terminal.failed" : "decisionGraph.terminal.cancelled")}
          </div>
        </div>
        <div className="mt-2 text-sm text-[var(--qn-foreground-muted)]" data-testid="dg-terminal-reason">
          {reason ? t("decisionGraph.terminal.reason", { reason }) : t("decisionGraph.terminal.reasonUnavailable")}
        </div>
        <div className="mt-3 text-[11px] text-[var(--qn-foreground-subtle)]">{t("decisionGraph.terminal.note")}</div>
      </motion.div>
    </div>
  );
}
